import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TradingChart from '../../components/Chart/TradingChart';
import './Market.css';

const Market: React.FC = () => {
  const { t } = useTranslation();
  const [selectedSymbol, setSelectedSymbol] = useState('BTCUSDT');

  const symbols = [
    { symbol: 'BTCUSDT', price: 50250, change: 2.5 },
    { symbol: 'ETHUSDT', price: 2520, change: 1.8 },
    { symbol: 'BNBUSDT', price: 315, change: -0.5 },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>{t('nav.market')}</h1>
      </div>

      <div className="grid grid-2">
        <div className="card market-card">
          <h2>Market List</h2>
          {symbols.map((item) => (
            <div
              key={item.symbol}
              onClick={() => setSelectedSymbol(item.symbol)}
              className={`market-list-item ${selectedSymbol === item.symbol ? 'selected' : ''}`}
            >
              <div className="market-list-item-row">
                <span className="market-list-item-symbol">{item.symbol}</span>
                <span className="market-list-item-price">${item.price.toLocaleString()}</span>
              </div>
              <span className={`market-list-item-change ${item.change >= 0 ? 'positive' : 'negative'}`}>
                {item.change >= 0 ? '+' : ''}{item.change}%
              </span>
            </div>
          ))}
        </div>

        <div className="card market-card">
          <TradingChart symbol={selectedSymbol} data={[]} width={600} height={400} />
        </div>
      </div>
    </div>
  );
};

export default Market;
